import {createAction, props} from '@ngrx/store';

enum actionTypes {
  userAuthenticated = 'USER_AUTHENTICATED',
}

export const userAuthenticated = createAction(
  actionTypes.userAuthenticated,
  props<{payload: any}>()
);
